<template>
  <svg
    viewBox="0 0 16 16"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true">
    <circle
      cx="8"
      cy="8"
      r="6.5" />
    <path d="M8 7.4v3.4" />
    <circle
      cx="8"
      cy="5.3"
      r="0.5"
      fill="currentColor"
      stroke="none" />
  </svg>
</template>
